import { AxiosResponse } from 'axios'
import { Repository } from './repository'

class ProgramRepository extends Repository {
  URL = 'recordings/programs/'

  bulkUpdate(
    ids: string[],
    {
      streams = undefined,
      enabled = undefined,
      captureVideo = undefined,
      token = undefined,
      backend = undefined,
    }: {
      streams?: boolean
      enabled?: boolean
      captureVideo?: boolean
      token?: string
      backend?: string
    },
  ): Promise<AxiosResponse<any>> {
    return this.axios.post(`recordings/programs/bulk-update/`, {
      'ids': ids,
      'streams': streams,
      'enabled': enabled,
      'capture_video': captureVideo,
      'yandex_token': token,
      'backend': backend,
    })
  }
  bulkCopy(ids: string[], { source, streams }): Promise<AxiosResponse<any>> {
    return this.axios.post(`recordings/programs/bulk-copy/`, { ids, source, streams })
  }
  bulkDelete(ids: string[]): Promise<AxiosResponse<any>> {
    return this.axios.post(`recordings/programs/bulk-delete/`, { ids })
  }
}

export { ProgramRepository }
